import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import AccessTime from '@material-ui/icons/AccessTime';
import DateRange from '@material-ui/icons/DateRange';
import { getHelpOrError, hasError } from './_common';
import RenderDay from './datepicker-render-day';

const Picker = (props) => {
  const {
    label,
    name,
    errors,
    value,
    help,
    onChange,
    onBlur,
    required,
    disablePast,
    clearable,
    minDate,
    maxDate,
    openTo,
    ...rest
  } = props;

  const ref = React.useRef(null);
  const w = useIntl().formatMessage({ id: 'week', defaultMessage: 'week' })[0];
  return (
    <DateTimePicker
      name={name}
      value={value}
      onChange={(v) => {
        onChange(v);

        setTimeout(() => {
          ref?.current?.blur();
        }, 50);
      }}
      onBlur={onBlur}
      disablePast={disablePast}
      clearable={clearable}
      format="LLLL"
      label={label}
      cancelLabel={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
      clearLabel={<FormattedMessage id="Clear" defaultMessage="Clear" />}
      margin="dense"
      inputProps={{
        ref,
        autoComplete: 'off',
      }}
      required={required}
      fullWidth
      autoOk
      minDate={minDate || undefined}
      maxDate={maxDate || undefined}
      openTo={openTo}
      error={hasError(errors, name)}
      helperText={getHelpOrError(help, errors, name)}
      ampm={false}
      renderDay={(d, sd, dicm, c) => RenderDay(d, sd, dicm, c, w)}
      timeIcon={<AccessTime />}
      dateRangeIcon={<DateRange />}
      {...rest}
    />
  );
};

Picker.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  errors: PropTypes.shape({}),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  help: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  disablePast: PropTypes.bool,
  clearable: PropTypes.bool,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  openTo: PropTypes.string,
};

export default Picker;
